import React,{useState} from 'react'
import FormButtom from "../../../../../components/common/forms/FormButtom";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";
import MainObjectives from "../../../../../components/common/forms/MainObjectives";
import { upload_document, upload_document_v2 } from "./CompanyObjectChanges";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import BusinessSearchNDetails from '../../../../../components/common/forms/BusinessSearchNDetails';
import { toast } from 'react-toastify';
import api from '../../../../../api/api';

const OldCmpObj = () => {
    const { register, handleSubmit } = useForm();
    const [docsOutput, setDocsOutput] = useState([]);
    const [cmpId, setCmpId] = useState(null);
    const [uploadProof, setUploadProof] = useState('')

    const handleClick = (data) => {
        // data.share_holders = shareHolders
        data.documents = docsOutput
        data.company = cmpId
        data.amendment_type = "objective_change";
        console.log(data)
    
        const user = JSON.parse(localStorage.getItem("user"))
    
        api.post('services/company/amendments/', data)
        .then((response) => {
          // console.log("success");
          // console.log(response.data);
          toast.success("Data Registered Successfully")
          // let transactions = {
          //   // payment_mode: "e_wallet",
          //   amount: 2500,
          //   service_object_id: response.data.service_object_id,
          //   created_by: response.data.service_object_id,
          //   service_object_content_type: response.data.service_content_type_id,
          //   payment_proof : uploadProof,
          //   company : cmpId,
          //   transaction_type: "credit"
         
          // };
  
          
          // api
          // .post("/transactions/", transactions)
          // .then((response) => {
          //   toast.success("Data Registered 2 Successfully.");
          // })
          // .catch((error) => {
          //   toast.error("Error in Transaction");
          // });
        })
        .catch((error) => {
          // console.log("error", error);
          toast.error("Something went wrong")
        });
        
    
      }
    
      let data = [];
      upload_document.map((item, i) => {
        data.push({ id: uuidv4(), image: "", document_name: "" });
        return ''
      });

  return (
    <form>
        {/* company name and other details */}
        {/* <div className="flex-col flex md:flex-row flex-wrap">
          <div className="flex flex-wrap border-2 border-primary-blue">
            <p className="text-primary-red flex-nowrap items-center shrink-0 flex font-bold text-base">
              कम्पनी वा ब्यवसायको नाम:
            </p>
            <input className="py-2" type="search" placeholder="Search" />
          </div>
          <div className="flex flex-wrap w-fit border-2 border-primary-blue">
            <p className="text-primary-red flex items-center font-bold text-base">
              ठेगाना :
            </p>
            <input className=" " type="" placeholder="" />
          </div>
          <div className="flex flex-wrap w-fit border-2 border-primary-blue">
            <p className="text-primary-red flex items-center font-bold text-base">
              स. ब्यक्तिको नाम :
            </p>
            <input className=" " type="text" placeholder="" />
          </div>
          <div className="flex flex-wrap w-fit border-2 border-primary-blue">
            <p className="text-primary-red flex items-center font-bold text-base">
              सम्पर्क नं. :
            </p>
            <input className=" " type="text" placeholder="" />
          </div>
          <div className="flex flex-wrap w-fit border-2 items-center border-primary-blue">
            <p className="text-primary-red font-bold text-base">
              शेयर सदस्य संख्या :
            </p>
            <input className="py-2" type="text" placeholder="" />
          </div>
        </div> */}
        <BusinessSearchNDetails setCmpId={setCmpId}/>
        <div className="w-full flex md:border-x-2 border-b borer-b-0 border-primary-blue border-b-2 flex-col md:flex-row ">
          <div className="p-3 text-red-600">
          थप गर्ने उद्देश्यहरु : 1
            <input type="text" className="outline-none" />
          </div>
          <div className="p-3 text-red-600">
          2 :
            <input type="text" className="outline-none" />
          </div>
          <div className="p-3 text-red-600">
          3 :
            <input type="text" className="outline-none" />
          </div>
          <div className="p-3 text-red-600">
          4 :
            <input type="text" className="outline-none" />
          </div>
        </div>
        <div className="border-2 bg-pink-100 border-primary-blue border-t-0">
          <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
            शेयर सदस्यहरुको संख्याको आधारमा कम्पनीको उद्देश्यहरु थपघट सम्बन्धि
            काम गर्दा तपाईको जम्मा लाग्ने रकम <span className='text-red-600'> रु.१५,०००।– </span>मात्र ।
          </p>
        </div>
        <div className='text-primary-blue text-center p-3'>
        <span className='text-red-600 underline'> नोट:</span> माथी उल्लेखित रकम ७ जना सम्म शेयर सदस्यहरु भएमा मात्र लागु हुनेछ, यदि ७ जना भन्दा बढि भएमा प्रती सदस्य <span className='text-red-600'> रु.५००।–</span>को दरले थप शुल्क बृद्धि हुदै जानेछ ।
        </div>

        {/* compnay name and other details close */}
        <div className='text-primary-blue text-lg font-Calistoga underline my-3'> 2.Main Objective </div>
        <MainObjectives register={register} name="new_objectives"/>

        <div className="border-2 bg-pink-100 border-primary-blue mt-3">
          <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
            शेयर सदस्यहरुको संख्याको आधारमा कम्पनीको उद्देश्यहरु थपघट सम्बन्धि
            काम गर्दा तपाईको जम्मा लाग्ने रकम रु.१५,०००।– मात्र ।
          </p>
        </div>

        {/* upload documents open */}
        <div className="text-primary-blue  text-lg underline my-4">
          3. Upload Document
          <span className="text-primary-blue underline">
            (शेयर लगत निकाल्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु ग्उयिबम
            गर्नुहोस ।)
          </span>
        </div>

        
       
        <Documents
          documents_data={upload_document}
          initialState={data}
          setDocument={setDocsOutput}
        />
            <div className="text-primary-blue text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>

        <FormBranch register={register} name={'working_branch'}/>
        <FormButtom />
        
        <NewFormPayment
        handleSubmit={handleSubmit}
        handleClick={handleClick}
        setUploadProof={setUploadProof}

       />
        </form>
  )
}

export default OldCmpObj